import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import styles from "../styles/auth.module.css";
import { BACKEND_URL } from "../config";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        // Définir le titre de la page
        document.title = "Memory Curve";
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${BACKEND_URL}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();
            if (response.ok) {
                sessionStorage.setItem("user_id", data.user_id);
                navigate("/main");
            } else {
                alert(data.detail);
            }
        } catch (error) {
            console.error("Error during login:", error);
            alert("An error occurred. Please try again.");
        }
    };

    const handleGoogleLogin = async () => {
        try {
            const response = await fetch(`${BACKEND_URL}/auth/google`);
            const data = await response.json();
            if (data.url) {
                window.location.href = data.url;
            } else {
                alert("Error getting Google authentication URL");
            }
        } catch (error) {
            console.error("Error initiating Google login:", error);
            alert("An error occurred. Please try again.");
        }
    };

    return (
        <div className={styles.authContainer}>
            <Link to="/" className={styles.backButton}>← Back</Link>
            <h1>Login</h1>
            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <label>Email:</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className={styles.formGroup}>
                    <label>Password:</label>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button type="submit" className={styles.submitButton}>Continue</button>
            </form>

            <div className={styles.divider}>
                <hr />
                <span>or</span>
                <hr />
            </div>

            <div className={styles.googleLogin}>
                <button onClick={handleGoogleLogin} className={styles.googleBtn}>
                    <img src="/g-logo.png" alt="Google logo" className={styles.googleIcon} />
                    <span>Continue with Google</span>
                </button>
            </div>

            <p className={styles.authSwitch}>
                Don't have an account? <a href="/register">Register here</a>
            </p>
        </div>
    );
};

export default Login;
